<template>
  <div>
    <div class="vx-row">
      <vs-alert
        class="mb-6 mx-4"
        color="danger"
        title="Activate your profile"
        :active="!activatedProfile"
      >
        Your tags are not active. You should only activate your tags as soon as you have received them.<br />
        <vs-button
          class="ml-auto mt-2"
          @click="activateProfile"
          >Activate your profile now</vs-button
        >
      </vs-alert>
      <vs-alert
        class="mb-6 mx-4"
        color="danger"
        title="Details missing"
        :active="showDataReminder && !firstLogin"
      >
        Your company details have not yet been updated so your tags might not
        work as expected.<br />
        <vs-button
          v-if="showDetailsUpdateButton"
          class="ml-auto mt-2"
          @click="$router.push('/settings/details')"
          >Update business details</vs-button
        >
        <br/>
        <vs-button
          v-if="showProfileUpdateButton"
          class="mt-2"
          @click="$router.push('/profile')"
          >Update profile</vs-button
        >
      </vs-alert>

      <!-- CARD SELECTED -->
      <div class="flex w-full vx-row no-gutter items-center justify-center">
        <div class="vx-col mb-base" style="width:330px">
          <vx-card
            slot="no-body"
            class="w-full">
            <div class="flex justify-center flex-row items-center" style="height:150px">
              <img v-if="userData.avatar" key="onlineImg" :src="userData.avatar" alt="user-img" style="height:80px;max-width:300px" />
            </div>
          </vx-card>
        </div>
      </div>


      <!-- CARD 1: CONGRATS -->
      <div v-if="firstLogin" class="vx-col w-full mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
        >
          <img
            src="@/assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="@/assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">Welcome {{ AppActiveUser.displayName }}!</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            Get started by completing your company details
          </p>
          <vs-button
            class="ml-auto mt-6"
            @click="$router.push('/settings/details')"
            >Create business details</vs-button
          >
          <br/>
          <vs-button
            class="mt-2"
            @click="$router.push('/profile')"
            >Update profile</vs-button
          >
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
        <dashboard-card
          link="profile"
          icon="EditIcon"
          title="View/Edit Business Profile"
        ></dashboard-card>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
        <dashboard-card
          link="settings/tags"
          icon="TagIcon"
          title="View/Edit Tag Actions"
        ></dashboard-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
        <dashboard-card
          link="settings/details"
          icon="UserIcon"
          title="View/Edit Account"
        ></dashboard-card>
      </div>


      <div class="vx-col w-full mb-base">
        <h3>Tap Stats</h3>
      </div>
      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"> <!-- vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base -->
        <statistics-card-line
          tagSource="card"
          icon="CreditCardIcon"
          title="Card stats"
          :statistic="totalCardTaps"
          statisticTitle="total taps"
          :chartData="subscribersGained.series"
          type="area"
        ></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line
          tagSource="keyring"
          icon="TagIcon"
          title="Keyring stats"
          :statistic="totalKeyringTaps"
          statisticTitle="total taps"
          :chartData="ordersRecevied.series"
          color="warning"
          type="area"
        ></statistics-card-line>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import DashboardCard from '@/components/dashboard-cards/DashboardCard.vue'

export default {
  components: {
    StatisticsCardLine,
    DashboardCard
  },
  data () {
    return {
      subscribersGained: {},
      ordersRecevied: {},
      totalCardTaps: 0,
      totalKeyringTaps: 0,
      userId: '',
      showDataReminder: false,
      showProfileUpdateButton: false,
      showDetailsUpdateButton: false,
      firstLogin: false,
      activatedProfile: true,
      userData: {}
    }
  },
  computed: {
    AppActiveUser () {
      return this.$store.state.AppActiveUser
    }
  },
  created () {
    if (this.AppActiveUser.uid === 0) {
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'UPDATE_USER_INFO') {
          if (state.AppActiveUser !== 0) {
            this.getDetails()
            this.userId = this.AppActiveUser.uid
          }
        }
      })
    } else {
      this.getDetails()
      this.getStats()
      this.userId = this.AppActiveUser.uid
      this.checkDetailsComplete()
    }
  },
  beforeDestroy () {
    const unsubscribe = this.$store.subscribe(() => {})
    unsubscribe()
  },
  methods: {
    checkDetailsComplete () {
      this.$fs.collection('client').doc(this.userId).get()
        .then(doc => {
          const data = doc.data()
          if (data.avatar === undefined && data.avatar === '') {
            this.showProfileUpdateButton = true
            this.showDataReminder = true
          }
          this.firstLogin = data.firstLogin
          this.activatedProfile = data.activated
          if (data.firstLogin) this.updateProfile()
        })

      this.$fs.collection('client').doc(this.userId).collection('profile').get()
        .then(docsData => {
          const data = docsData.docs[0].data()
          if ((data.businessName === undefined && data.businessName === '') || (data.contactName !== undefined && data.contactName !== '')) {
            this.showDetailsUpdateButton = true
            this.showDataReminder = true
          }
        })
    },
    updateProfile () {
      this.$fs.collection('client').doc(this.userId).update({
        firstLogin: false
      })
        .catch(error => {
          console.log(error)
        })
    },
    activateProfile () {
      this.$fs.collection('client').doc(this.userId).update({
        activated: true
      })
        .then(() => {
          this.activatedProfile = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStats () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').get()
        .then(actions => {
          actions.docs.forEach(action => {
            if (action.id === 'card' && action.data().totalTaps !== undefined) this.totalCardTaps = action.data().totalTaps
            if (action.id === 'keyring' && action.data().totalTaps !== undefined) this.totalKeyringTaps = action.data().totalTaps
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDetails () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).get()
        .then(user => {
          this.userData = user.data()
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss">
.decore-left{
  position: absolute;
  left:0;
  top: 0;
}
.decore-right{
  position: absolute;
  right:0;
  top: 0;
}
</style>
